<template>
    <button class="ur-segment-button line-break ico"
            :class="segmentButtonClass"
            @click.stop="onClick">
    <!--
        $ver: v0.1.0
        버튼 내부에 위치하는 영역입니다. 일반적으로 버튼 텍스트가 사용됩니다.
        #The area located inside the button. Typically button text is used.
     --><slot />
    </button>
</template>

<script>
//ur-segment-button은 하나의 세그먼트로 묶여서 제공되는 버튼 컴포넌트입니다.
//#ur-segment-button is one of related buttons inside of a Segment.
    export default {
        name: 'aicc-segment-button',
        model: {
            prop: 'checked'
        },
        inject: {
            urSegmentWrapper: {from: 'urSegmentWrapper', default: () => undefined},
            urInput: {from:'urInput', default: () => undefined}
        },
        props: {
            // $ver: v0.1.2
            // $v-model
            // v-model로 바인딩되는 값으로, <em>ur-segment-wrapper</em>를 사용할 경우
            // ur-segment-wrapper의 v-model값을 우선시하고 ur-segment-button의 v-model은 무시됩니다.
            // 단일 세그먼트버튼으로 사용되는 경우에만 Boolean, String 타입을 사용하고 다중선택이 필요한경우 Array타입을 사용해야 합니다.
            // # Binding to v-model. If <em>ur-segment-wrapper</em> component used,
            // # v-model of this ur-segment-button is ignored and v-model of ur-segment-wrapper is used instead.
            // # Boolean and String type is only used in single segment-button use-case. Array type has to be set when using multiple select use-case.
            checked: {
                type: [Boolean, String, Array],
            },
            // $ver: v0.1.0
            // 선택되었을 때 v-model의 값으로 설정되는 목표값입니다.
            // # If component is checked, v-model is set as this value.
            // $default: true
            value: {
                type: [String, Boolean, Number, Array, Object],
                default: true
            },
            // $ver: v0.1.2
            // <em>ur-checkbox-wrapper</em>와 함께 사용할 때 wrapper 하위에 위치하는 모든 체크박스가 아닌
            // 특정 체크박스에만 validate를 적용하고 싶을 경우 group이름을 지정하여 분리할 수 있습니다.
            // #When used with <em>ur-checkbox-wrapper</em>, you can separate it by specifying the group name
            // #if you want to apply validate only to a specific checkbox rather than to all the checkboxes under the wrapper.
            group: {
                type: String,
                default: 'default'
            },
            // $ver: v0.1.2
            // 상호작용 불가능한 상태를 만듭니다.
            // #Set a non-interactive state.
            // $default: false
            disabled: {
                type: Boolean,
                default: false
            },
            // $ver: v0.2.0
            // 색상 유형 입니다. 'primary','point','normal', 'red', 'orange', 'green' 유형 중 하나를 입력해야 합니다.
            // #The color type. You must enter one of these types: 'primary','point','normal', 'red', 'orange', 'green'.
            // $default: normal
            color:{
                validator: function (value) {
                // The value must match one of these strings
                return ['primary', 'point', 'normal', 'red', 'orange', 'green'].indexOf(value) !== -1
                },
            },
            // $ver: v0.1.2
            // 선택된 <em>ur-segment-button</em>의 색상을 Primary 색상으로 정의합니다.
            // #Defines the color of the selected <em>ur-segment-button</em> as the primary color.
            primary: {
                type: Boolean,
            },
            // $ver: v0.1.2
            // $abbr: primary
            prim: {
                type: Boolean,
            },
            // $ver: v0.1.2
            // 선택된 <em>ur-segment-button</em>의 색상을 Point 색상으로 정의합니다.
            // #Defines the color of the selected <em>ur-segment-button</em> as the point color.
            point: {
                type: Boolean,
            },
            // $ver: v0.1.2
            // $abbr: point
            pnt: {
                type: Boolean,
            },
            // $ver: v0.1.2
            // 모양새를 solid-button 스타일로 정의합니다.
            // #Define the appearance in solid-button style.
            // $default: false
            solid: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // $abbr: solid
            sol: {
                type:Boolean,
                default: false,
            },
            // $ver: v0.1.2
            // 모양새를 border-button 스타일로 정의합니다.
            // #Define the appearance in the border-button style.
            // $default: false
            border: {
                type: Boolean,
                default: false
            },
            // $ver: v0.1.2
            // $abbr: border
            bor: {
                type:Boolean,
                default: false,
            },
            // $ver: v0.2.0
            // 세그먼트 버튼의 크기를 결정합니다. 'large', 'small', 'medium' 세 가지 중 하나를 입력해야 합니다.
            // #The size You must enter one of three types: large, small or medium.
            size:  {type: String, default: undefined},
            // $ver: v0.1.2
            // 크기를 large으로 정의합니다. 기본크기입니다.
            // #Define the size as large.
            // $default: false
            large: {
                type: Boolean,
                default: false
            },
            // $abbr: large
            lg: {type:Boolean},
            // $ver: v0.1.2
            // 크기를 medium으로 정의합니다. 기본크기입니다.
            // #Define the size as medium. The default size.
            // $default: false
            medium: {
                type: Boolean,
                default: false
            },
            // $abbr: medium
            md: {type:Boolean},
            // $ver: v0.1.2
            // 크기를 small로 정의합니다.
            // #Define the size as small.
            // $default: false
            small: {
                type: Boolean,
                default: false
            },
            // $abbr: small
            sm: {type:Boolean},

            // 시나리오 산업군 아이콘
            ico: {
                type: String,
                default: 'common',
            },
        },

        data() {
            return {
                default : {
                    size: 'medium',
                    style: 'border',
                    color: 'default'
                }
            };
        },
        computed: {
            $_urSegmentWrapper() {
                return this.urSegmentWrapper && this.urSegmentWrapper[this.group];
            },
            $_style() {
                if(this.border || this.bor) {return 'border'}
                if(this.solid || this.sol) {return 'solid'}
                if(this.$_urSegmentWrapper && this.$_urSegmentWrapper.style) {return this.$_urSegmentWrapper.style;}
                return this.default.style;
            },
            $_color() {
                if(this.color) {return this.color}
                if(this.primary || this.prim) {return 'primary'}
                if(this.point || this.pnt) {return 'point'}
                if(this.$_urSegmentWrapper && this.$_urSegmentWrapper.color) {return this.$_urSegmentWrapper.color;}
                return this.default.color;
            },
            $_size() {
                if(this.size ==='medium'|| this.medium || this.md) {return 'medium'}
                if(this.size ==='large'|| this.large || this.lg) {return 'large'}
                if(this.size ==='small'|| this.small || this.sm) {return 'small'}
                if(this.urInput) {return this.urInput.size;}
                return this.default.size;
            },
            actualVModel() {
                if(this.$_urSegmentWrapper) {
                    if(this.checked){
                        console.warn('[UR-SEGMENT-BUTTON] if you use ur-segment-wrapper, v-model(=checked props) of ur-segment-button itself is being ignored.');
                    }
                    return this.$_urSegmentWrapper.checked;
                }
                return this.checked;
            },
            clicked() {
                if (typeof(this.value) == 'boolean') {
                    // Boolean
                    if(this.actualVModel==='Y') return true;
                    if(this.actualVModel==='N') return false;
                    return this.actualVModel;
                }
                else {
                    if (Array.isArray(this.actualVModel)) {
                        // Array
                        return (this.actualVModel.indexOf(this.value) >= 0);
                    }
                    else {
                        // String
                        return this.actualVModel === this.value;
                    }
                }
            },
            segmentButtonClass() {
                let clazz = [];
                if (this.disabled || (this.$_urSegmentWrapper && this.$_urSegmentWrapper.disabled)) {
                    clazz.push('ur-segment-button--disabled');
                }
                clazz.push('ur-segment-button--'+this.$_color);
                clazz.push('ur-segment-button--'+this.$_style);
                clazz.push('ur-segment-button--'+this.$_size);
                if(this.clicked) {
                    clazz.push('ur-segment-button--checked');
                }
                if(this.$_urSegmentWrapper && this.$_urSegmentWrapper.hasError) {
                    clazz.push('ur-validator--error')
                }

                // 시나리오 산업군 아이콘 클래스 추가
                clazz.push(this.ico.toLowerCase());

                return clazz;
            }
        },
        methods: {
            onClick(e) {
                // $ver: v0.1.2
                // $arg: click event
                // click 시 이벤트를 호출합니다.
                // # Call event on click.
                this.$emit('click',e);
                if(this.$_urSegmentWrapper) {this.$_urSegmentWrapper.click(e);}

                if (typeof(this.value) === 'boolean') {
                    if(this.actualVModel==='Y') {this.emit('N');}
                    else if(this.actualVModel==='N'){this.emit('Y');}
                    else {
                        this.emit(!this.actualVModel);
                    }
                } else {
                    if (Array.isArray(this.actualVModel)) {
                        if (this.actualVModel.indexOf(this.value) >= 0) {
                            // if exist, remove it
                            this.emit(this.actualVModel.filter(item => item !== this.value));
                        }
                        else {
                            // if not exist, append it
                            this.emit(this.actualVModel.concat(this.value));
                        }
                    }
                    else {
                        // String type v-model
                        if(this.$_urSegmentWrapper&&this.$_urSegmentWrapper.clearable) {
                            this.emit(this.actualVModel===this.value ? '' : this.value);
                        } else {
                            this.emit(this.value);
                        }
                    }
                }
            },
            emit(val) {
                if(this.$_urSegmentWrapper) {
                    this.$_urSegmentWrapper.emit(val);
                } else {
                    // $ver: v0.1.2
                    // $arg: updated v-model value
                    // v-model에 설정된값(checked)을 업데이트합니다.
                    // # update v-model value(checked props).
                    this.$emit('input', val);
                }
            }
        }
    };

</script>
